import React from "react";

const VSpace: React.FC = () => {
  return <div style={{ marginTop: "0.5rem" }} />;
};

export default VSpace;
